import { GettingStartedContent, getLocalizedContent } from "@onzeit/shared";
import { useParams } from "@remix-run/react";
import { GettingStarted } from "~/components";

export default function Index() {
  const { locale } = useParams();
  const content = getLocalizedContent(locale!, GettingStartedContent);
  return <GettingStarted content={content} locale={locale!} />;
}
